import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PicData = {
  MLW_NIPP: string;
  ACTION: string;
  
};

type InitialState = {
  dataPic: PicData[];
};

const initialState: InitialState = {
  dataPic: [
    
    // Add more data items as needed
  ],
};

export const picSlice = createSlice({
  name: 'picSlice',
  initialState,
  reducers: {
    allPic: (state, action: PayloadAction<PicData[]>) => {
      state.dataPic = action.payload; // Replace the entire array with the new array
    },
  },
});

export const { allPic } = picSlice.actions;
export default picSlice.reducer;
